import React, { useState } from 'react';
import { Input } from '@chakra-ui/react';
import { useSearchParams } from "react-router-dom";

const CustomTitleSearch = ({ setSearchString }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchValue, setSearchValue] = useState(searchParams.get("searchName") || "");

  return (
    <Input
      value={searchValue}
      placeholder='Search by name'
      onChange={(e) => {
        if (e.target.value === '') {
          setSearchString(null);
          setSearchValue("");
        } else {
          setSearchString(e.target.value);
          setSearchValue(e.target.value);
        }
      }}
    />
  );
};

export default CustomTitleSearch;
